import React from 'react';
import styled, { keyframes } from 'styled-components';

const shakeKeyframes = keyframes`
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
`;

const Wrapper = styled.div`
  padding: 80px 20px 20px;
  text-align: center;

  > h1 {
    animation: ${shakeKeyframes} 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
    animation-delay: 0.2s;
    font-size: 40px;
    margin: 0;
    padding: 0;
  }
  > p {
    font-size: var(--medium);
  }
`;

type Props = {
  title?: string;
  text: string;
};

function ErrorPage({ title, text }: Props) {
  return (
    <Wrapper>
      <h1>{title}</h1>
      <p>{text}</p>
    </Wrapper>
  );
}

export default ErrorPage;
